var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-wrapper', [_c('div', {
    staticClass: "blog-post-header"
  }, [_c('div', {
    staticClass: "blog-title"
  }, [_c('h2', [_vm._t("default", [_vm._v(" Duis dapidus aliquam mi, eget euismod sem scelerisque ut.")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "datum-header"
  }, [_vm._t("default", [_vm._v("25 May 2013")]), _vm._v(",\n        ")], 2), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._t("default", [_vm._v("\n                Hosted by\n                "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Admin")]), _vm._v(" in\n                "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Wordpress")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._t("default", [_vm._v("Design")])], 2), _vm._v(" ,\n            "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._t("default", [_vm._v("Template")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._t("default", [_vm._v("22")])], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-023d9d5e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/blog-post-header/blog-post-header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-023d9d5e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/blog-post-header/blog-post-header.vue
// module chunks = index